import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ClientType } from "../../../Types/Client";
import { Language, ProfileType } from "../../../Types/General";

interface AccountCreationState {
    Language: Language | undefined
    ProfileType: ProfileType | undefined;
    CompanyName: string | undefined;
    FirstName: string | undefined;
    LastName: string | undefined;
    Email: string | undefined;
    Password: string | undefined;
    PasswordConfirmation: string | undefined;
    Country: string | undefined;
    CountryCode: string | undefined;
    IdType: string | undefined;
    IdNumber: string | undefined;
    PhoneNumber: string | undefined;
    ClientType: ClientType | undefined;
    Progress: number;
    Subtitle: string;
    BirthDate: string | undefined;
}

const initialState: AccountCreationState = {
    Language: undefined,
    ProfileType: undefined,
    CompanyName: undefined,
    FirstName: undefined,
    LastName: undefined,
    Email: undefined,
    Password: undefined,
    PasswordConfirmation: undefined,
    Country: undefined,
    CountryCode: undefined,
    IdType: undefined,
    IdNumber: undefined,
    PhoneNumber: undefined,
    ClientType: undefined,
    Progress: 25,
    Subtitle: '',
    BirthDate: undefined
}

export const accountCreationSlice = createSlice({
    name: 'AccountCreation',
    initialState,
    reducers: {
        setLanguage(state, action: PayloadAction<AccountCreationState['Language']>){
            state.Language = action.payload
        }, 
        setProfileType(state, action: PayloadAction<AccountCreationState['ProfileType']>){
            state.ProfileType = action.payload
        }, 
        setCompanyName(state, action: PayloadAction<AccountCreationState['CompanyName']>){
            state.CompanyName = action.payload
        },
        setFirstName(state, action: PayloadAction<AccountCreationState['FirstName']>){
            state.FirstName = action.payload
        },
        setLastName(state, action: PayloadAction<AccountCreationState['LastName']>){
            state.LastName = action.payload
        },
        setEmail(state, action: PayloadAction<AccountCreationState['Email']>){
            state.Email = action.payload
        },
        setPassword(state, action: PayloadAction<AccountCreationState['Password']>){
            state.Password = action.payload
        },
        setPasswordConfirmation(state, action: PayloadAction<AccountCreationState['PasswordConfirmation']>){
            state.PasswordConfirmation = action.payload
        },
        setCountry(state, action: PayloadAction<AccountCreationState['Country']>){
            state.Country = action.payload
        },
        setIdType(state, action: PayloadAction<AccountCreationState['IdType']>){
            state.IdType = action.payload
        },
        setIdNumber(state, action: PayloadAction<AccountCreationState['IdNumber']>){
            state.IdNumber = action.payload
        },
        setPhoneNumber(state, action: PayloadAction<AccountCreationState['PhoneNumber']>){
            state.PhoneNumber = action.payload
        },
        setClientType(state, action: PayloadAction<AccountCreationState['ClientType']>){
            state.ClientType = action.payload
        },
        setProgress(state, action: PayloadAction<AccountCreationState['Progress']>){
            state.Progress = action.payload
        },
        setSubtitle(state, action: PayloadAction<AccountCreationState['Subtitle']>){
            state.Subtitle = action.payload
        },
        setBirthDate(state, action: PayloadAction<AccountCreationState['BirthDate']>){
            state.BirthDate = action.payload
        },
        setCountryCode(state, action: PayloadAction<AccountCreationState['CountryCode']>){
            state.CountryCode = action.payload
        },
        resetState() {
            return initialState
        }
    }
})

export const {
    setLanguage,
    setProfileType,
    setCompanyName,
    setFirstName,
    setLastName,
    setEmail,
    setPassword,
    setPasswordConfirmation,
    setCountry,
    setIdType,
    setIdNumber,
    setPhoneNumber,
    setClientType,
    setProgress,
    setSubtitle,
    setBirthDate,
    setCountryCode,
    resetState
} = accountCreationSlice.actions

export default accountCreationSlice.reducer

